export function applyGameplayArtPass4(stage) {
  if (!stage || stage.dataset.parityPass4Applied === 'true') return;
  stage.dataset.parityPass4Applied = 'true';

  // Pass 3's replacement support blocks regressed the approved opening
  // composition by covering holes and flattening the lower assembly. Restore
  // the proven Pass 2 geometry and retain only the useful Pass 3 detail work.
  stage.querySelectorAll('.bf-pass3-support').forEach((node) => node.remove());
  stage.querySelectorAll('.bf-pass3-replaced').forEach((node) => {
    node.classList.remove('bf-pass3-replaced');
  });
}
